export default "__VITE_ASSET__DsHNkDZr__"